<template>
    <div class="main-link">
        <v-row no-gutters>
            <v-col cols="12" xl="6">
                <v-card img="/images/main/main-link-bg.jpg" href="/#efesta" class="main-link-card">
                    <div class="main-link-card__inner">
                        <div class="main-link-card__number mb-20px mb-xl-40px" style="background-image:url(/images/main/01.svg)" />
                        <h2 class="tit tit--xxl">e커머스<br />피칭페스타</h2>
                        <div class="main-link-card__arrow">
                            <icon-arrow-rounded direction="right" class="white--text" />
                        </div>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" xl="6">
                <v-card img="/images/main/main-link-bg2.jpg" href="/#circulation" class="main-link-card">
                    <div class="main-link-card__inner">
                        <div class="main-link-card__number mb-20px mb-xl-40px" style="background-image:url(/images/main/02.svg)" />
                        <h2 class="tit tit--xxl">유통데이터<br />활용 경진대회</h2>
                        <div class="main-link-card__arrow">
                            <icon-arrow-rounded direction="right" class="white--text" />
                        </div>
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import IconArrowRounded from "@/components/client/icons/icon-arrow-rounded.vue";

export default {
    props: {},
    components: {
        IconArrowRounded,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.main-link {
    [class*="col-"] {
        &:nth-child(1) {
            .main-link-card {
                &__inner {
                    padding-top: var(--header-head);
                }
            }
        }
        &:nth-child(even) {
            text-align: right;
            .main-link-card {
                &__arrow {
                    right: auto;
                    left: 0;
                }
                &__number {
                    background-position: right center;
                }
            }
        }
    }
}
.main-link-card {
    position: relative;
    display: flex;
    align-items: center;
    height: 50vh;
    transition: all ease-out 0.4s;
    &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: block;
        width: 100%;
        height: 100%;
        background-color: #000;
        opacity: 0.6;
        transition: all ease-out 0.2s;
    }
    &__inner {
        position: relative;
        width: 100%;
        margin: 60px var(--container-gutter);
    }
    &__number {
        height: 60px;
        background-repeat: no-repeat;
        background-position: left center;
        background-size: contain;
        transition: all ease-out 0.4s;
    }
    &__arrow {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        display: flex;
        justify-content: center;
        align-content: center;
        width: 60px;
        height: 60px;
        border-radius: 100%;
        transition: all ease-out 0.2s;
        &::after {
            width: 100%;
            height: 100%;
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
            background-image: url(/images/main/main-link-more.png);
            animation: spin 10s infinite linear;
        }
    }
    .tit {
        color: transparent !important;
        -webkit-text-stroke: 1px #fff;
        transition: all ease-out 0.4s;
    }
}
@keyframes spin {
    0% {
        transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
        transform: translate(-50%, -50%) rotate(360deg);
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .main-link-card {
        &__number {
            height: 70px;
        }
        &__arrow {
            width: 70px;
            height: 70px;
        }
    }
}
@media (min-width: 1024px) {
    .main-link-card {
        &__inner {
            margin: 60px;
        }
        &__arrow {
            opacity: 0;
        }
        &__number {
            height: 84px;
        }
        &:hover {
            &::before {
                opacity: 0.4;
            }
            .tit {
                color: #fff !important;
                -webkit-text-stroke: 1px transparent !important;
            }
            [style*="01.svg"] {
                background-image: url("/images/main/01-fill.svg") !important;
            }
            [style*="02.svg"] {
                background-image: url("/images/main/02-fill.svg") !important;
            }
            .main-link-card {
                &__arrow {
                    opacity: 1;
                }
            }
        }
    }
}
@media (min-width: 1200px) {
    .main-link {
        [class*="col-"] {
            &:nth-child(1) {
                .main-link-card {
                    &__inner {
                        padding-top: 0;
                    }
                }
            }
        }
    }
    .main-link-card {
        height: 100vh;
    }
}
@media (min-width: 1400px) {
    .main-link-card {
        &__inner {
            margin: 120px;
        }
        &__arrow {
            width: 136px;
            height: 136px;
        }
        &__number {
            height: 202px;
        }
    }
}
</style>
